<template>
    <ul class="BreadcrumbsList" v-if="loading || breadcrumbs.length > 0">
        <Breadcrumb v-for="(item, index) in breadcrumbs" :key="index" :loading="loading" :breadcrumb="item" @clickLink="onBreadcrumbClick"/>
    </ul>
</template>

<script setup lang="ts">
import IBreadcrumb from '@app/interfaces/dtos/IBreadcrumb';
import Breadcrumb from '@components/Breadcrumbs/Breadcrumb/Breadcrumb.vue';
import { useSearchStore } from '@stores/useSearchStore';
import { useRouter } from 'vue-router';
import { computed } from 'vue';

const store = useSearchStore();
const router = useRouter();
const loading = computed(() => store.loading);
const breadcrumbs = computed(() =>  store.pageData?.breadcrumbs || []);

const onBreadcrumbClick = async (breadcrumb: IBreadcrumb) => {
    if (breadcrumb.isLast) return;

    if (breadcrumb.isFirst) {
        window.location.href = '/';
        return;
    }

    if(breadcrumb.url === undefined) return;

    const url = new URL(breadcrumb.url);

    await router.push(url.pathname || '/');
    await store.loadPageData();
};
</script>

<style scoped lang="scss">
.BreadcrumbsList {
    display: flex;
    list-style-type: none;
    align-items: center;
    gap: 0.25rem;

    @include TextStyle(UiSmallRegular);
    @include PaddingAreas(0);
    @include MarginAreas(0);
}
</style>